export const HowItWorksId = 'howItWorks';
